import { formatDate, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Realisation, RealisationHourtype } from 'src/app/classes/realisation';
import { CodaltComponent } from 'src/app/codalt.component';
import { RealisationService } from 'src/app/services/realisation.service';
import { Utils } from 'src/app/utils.class';

@Component({
    selector: 'app-day-detail',
    templateUrl: './day-detail.component.html',
    styleUrls: ['./day-detail.component.scss'],
    standalone: false,
})
export class DayDetailComponent extends CodaltComponent implements OnInit {
    maxDate: Date;
    date: Date;
    nextDate: Date;
    realisations: Realisation[];
    notWorkRealisations: Realisation[];

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private realisationService: RealisationService,
        private location: Location
    ) {
        super();

        this.maxDate = this.realisationService.calcMaxDate();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.activatedRoute.params.subscribe((params: { date: string }) => {
                this.date = new Date(params.date);
                this.nextDate = new Date(this.date);
                this.nextDate.setDate(this.nextDate.getDate() + 1);
                if (this.date < this.maxDate) {
                    this.realisationService.getUserDaySchedule(this.date).subscribe(realisations => {
                        const userRealisations = realisations.data.realisations.filter(r => !!r.user_id);
                        this.realisations = userRealisations.filter(r => r.hourtype === RealisationHourtype.worktime);
                        this.notWorkRealisations = userRealisations.filter(r =>
                            [
                                RealisationHourtype.day_off,
                                RealisationHourtype.education,
                                RealisationHourtype.bank_holiday,
                                RealisationHourtype.frost,
                                RealisationHourtype.sleep,
                                RealisationHourtype.illness,
                                RealisationHourtype.travel_to,
                                RealisationHourtype.travel_back,
                                RealisationHourtype.driving_to,
                                RealisationHourtype.driving_back,
                            ].includes(r.hourtype)
                        );
                    });
                }

                window.scroll(0, 0);
            })
        );
    }

    next() {
        this.date.setDate(this.date.getDate() + 1);
        this.router.navigateByUrl(`weekschedule/${formatDate(this.date, 'yyyy-MM-dd', 'nl')}`);
    }

    prev() {
        this.date.setDate(this.date.getDate() - 1);
        this.router.navigateByUrl(`weekschedule/${formatDate(this.date, 'yyyy-MM-dd', 'nl')}`);
    }

    back() {
        if (window.history.length > 1) {
            this.location.back();
        } else {
            this.router.navigateByUrl(
                `weekschedule/${Utils.getWeekNumber(this.date)}/${formatDate(this.date, 'yyyy', 'nl')}`
            );
        }
    }
}
